import * as types from './constants';

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = {}, action) => {
  switch (action.type) {
    case types.SET_ACTIVE_USER:
      return { ...state, ...action.userInfo };
    default:
      return state;
  }
};
